import React from 'react';
import { Text, MessageModalLayout, Modal, TextButton } from 'wix-style-react';
import s from './delete-modal.scss';
export var DeletePremiumModal = function (_a) {
    var app = _a.app, handleClose = _a.handleClose, t = _a.t, msId = _a.msId;
    var title = t('manage-apps.delete-premium.header', {
        name: app.webSolutionBase.name,
    }).replace('&amp;', '&');
    var learnMoreTextButton = (React.createElement(TextButton, { as: "a", href: t('manage-apps.delete-premium-learn-more-link'), target: "_blank", onClick: handleClose, className: s.learnMoreTextButton }, t('manage-apps.delete-premium.side-action')));
    var onOkClick = function () {
        window.open("https://manage.wix.com/dashboard/" + msId + "/manage-website/plans", '_blank');
        handleClose();
    };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageModalLayout, { title: title, primaryButtonText: t('manage-apps.delete-premium.cta'), secondaryButtonText: t('manage-apps.delete-premium.cancel'), primaryButtonOnClick: onOkClick, secondaryButtonOnClick: handleClose, onCloseButtonClick: handleClose, dataHook: "delete-premium-app-modal" },
            React.createElement(Text, null,
                t('manage-apps.delete-premium.line1'),
                t('manage-apps.delete-premium.line2')),
            learnMoreTextButton)));
};
//# sourceMappingURL=delete-premium-modal.js.map